import Actions                           from 'Redux/Actions';
import { InvoiceRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from, EMPTY }                   from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';

export const downloadInvoicePdfEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.downloadInvoicePdfRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        InvoiceRepository.downloadInvoicePdf(id)
          .then(() => {
            return Actions.downloadInvoicePdfSuccess();
          })
          .catch((error: any) => Actions.downloadInvoicePdfFailure({ error })),
      );
    }),
  );
};
